<template>
  <div>
    <div v-if="dates.length > 0" id="shifts-calendar">
      <Calendar
        :min-date="currentDate"
        :attributes="attributes"
        v-model="date"
        is-expanded
      />
    </div>
    <div v-else class="option__notice_without-calendar">
      <span>Для вас пока не было добавлено расписания смен</span>
    </div>
  </div>
</template>

<script>
import { Calendar } from "v-calendar";
import { date } from "@/_shared/utils";
export default {
  components: {
    Calendar,
  },
  props: {
    dates: {
      type: Array | null,
      default() {
        return [];
      },
    },
    times: {
      type: Object | null,
      default() {
        return {};
      },
    },
  },
  computed: {
    timesCss() {
      return [
        'option__content_times',
        `${this.timesSize}-times`,
      ];
    },
    attributes() {
      const attributes = [];
      for (let timesDay in this.times) {
        const { start, end } = this.times[timesDay];
        attributes.push({
          highlight: 'blue',
          dates: [timesDay],
          popover: {
            label: `${start} - ${end}`,
            visibility: 'click',
            hideIndicator: true,
          },
        });
      }
      return attributes;
    },
    currentDate() {
      return new Date();
    },
  },
  mounted() {
    this.getTodayShiftTimes();
  },
};
</script>

<style scoped>
.option__notice_without-calendar {
  font-weight: 600;
  display: flex;
  align-items: center;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/_shared/features/work-shift-menu/ShiftsCalendar.vue